import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, Phone } from 'lucide-react';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '#hero'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Location',
    href: '#location'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  const scrollToSection = (href: string) => {
    setIsMobileMenuOpen(false);
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-black-rich/95 backdrop-blur-md border-b border-gold-900/30 py-2' : 'bg-transparent py-4'}`} data-id="element-177">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-178">
        <div className="flex items-center justify-between" data-id="element-179">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('#hero')} data-id="element-180">
            <img src="https://cdn.magicpatterns.com/uploads/hVzgNEN2Eeix5JoWytq8hx/we.png" alt="Kings Gold Smelters Logo" className="h-12 w-auto md:h-16 object-contain" data-id="element-181" />
            <span className={`font-bold text-white text-lg md:text-xl hidden sm:block ${isScrolled ? 'opacity-100' : 'opacity-0 md:opacity-100'} transition-opacity`} data-id="element-182">
              KINGS GOLD
            </span>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-183">
            {navLinks.map(link => <button key={link.name} onClick={() => scrollToSection(link.href)} className="text-gray-300 hover:text-gold-400 font-medium transition-colors text-sm uppercase tracking-wider" data-id="element-184">
                {link.name}
              </button>)}
            <button onClick={() => scrollToSection('#contact')} className="bg-gold-500 hover:bg-gold-400 text-black font-bold py-2 px-6 rounded-sm transition-colors flex items-center gap-2" data-id="element-185">
              <Phone className="w-4 h-4" data-id="element-186" />
              <span data-id="element-187">Book Now</span>
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden" data-id="element-188">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-white p-2" data-id="element-189">
              {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-190" /> : <Menu className="w-6 h-6" data-id="element-191" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-192">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-black-rich border-b border-gray-800 overflow-hidden" data-id="element-193">
            <div className="px-4 pt-2 pb-6 space-y-2" data-id="element-194">
              {navLinks.map(link => <button key={link.name} onClick={() => scrollToSection(link.href)} className="block w-full text-left px-3 py-4 text-base font-medium text-gray-300 hover:text-gold-400 hover:bg-gray-900 rounded-md transition-colors border-b border-gray-800 last:border-0" data-id="element-195">
                  {link.name}
                </button>)}
              <div className="pt-4" data-id="element-196">
                <button onClick={() => scrollToSection('#contact')} className="w-full bg-gold-500 hover:bg-gold-400 text-black font-bold py-3 px-6 rounded-sm transition-colors flex items-center justify-center gap-2" data-id="element-197">
                  <Phone className="w-4 h-4" data-id="element-198" />
                  <span data-id="element-199">Book Smelting Service</span>
                </button>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}